<template>

  <div>

    <v-breadcrumbs :items="breadcrumbs" class="mb-8">
      <template v-slot:divider>
        <v-icon icon="$breadcrumbSeparator"></v-icon>
      </template>
    </v-breadcrumbs>
    
    <slot></slot>

  </div>

</template>

<script setup lang="ts">

import type { VBreadcrumbsItem } from '../../types/vuetify'

interface Props {
  breadcrumbs?: VBreadcrumbsItem[]
}

withDefaults(defineProps<Props>(), {
  breadcrumbs: () => [],
})

</script>
